import { EnvService } from '../EnvService';

const envService = EnvService;

export const domainMap: { [key: string]: string } = {
  sjsistemas: envService.REACT_APP_SJ_SISTEMAS,
  app: envService.REACT_APP_APP,
  staging: envService.REACT_APP_STAGING,
  localhost: envService.REACT_APP_LOCALHOST
};
